import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="header-container">
      <h1>Random Chooser</h1>
      <h3>Choose Four Items</h3>
    </div>
  );
};

export default Header;
